"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { PenTool, Ruler, Home, Users, Clock } from "lucide-react";
export default function IntegratedDesignBuildServices() {
  const {
    ref: iconsRef,
    isVisible: iconsVisible
  } = useRevealOnScroll({
    threshold: 0.3,
    once: true
  });
  const {
    ref: paragraphRef,
    isVisible: paragraphVisible
  } = useRevealOnScroll({
    threshold: 0.5,
    once: true
  });
  const icons = [{
    Icon: PenTool,
    delay: "0ms"
  }, {
    Icon: Ruler,
    delay: "150ms"
  }, {
    Icon: Home,
    delay: "300ms"
  }, {
    Icon: Users,
    delay: "450ms"
  }, {
    Icon: Clock,
    delay: "600ms"
  }];
  const benefits = [{
    Icon: PenTool,
    text: "Clear communication",
    delay: "0ms"
  }, {
    Icon: Ruler,
    text: "Controlled budgets",
    delay: "150ms"
  }, {
    Icon: Home,
    text: "Reduced timelines",
    delay: "300ms"
  }, {
    Icon: Users,
    text: "Consistent quality from start to finish",
    delay: "450ms"
  }];
  return <section id="integrated-design-build-services" className="relative min-h-screen flex items-center justify-center overflow-hidden py-24 bg-white !text-[hsl(0,0%,100%)]">
      {}
  
      {}
      <div className="absolute inset-0 !bg-[hsl(0,0%,100%)]" />
  
      {}
      <div className="relative z-10 max-w-6xl mx-auto px-6 text-center">
        {}
        <div className="mb-8 flex items-center justify-center gap-4">
          <span className="text-xs uppercase tracking-[0.15em] !font-medium !text-[hsl(32,29%,42%)]">DESIGN & BUILD</span>
        </div>
  
        {}
        <h2 className="font-display font-bold text-foreground mb-6 !text-5xl">Integrated Design & Build Services</h2>
  
        {}
        <p className="text-lg text-foreground mb-12 max-w-2xl mx-auto leading-relaxed">Our design & build model offers a single point of responsibility,  ensuring seamless coordination between concept, construction, and delivery.</p>
  
        {}
        
  
        {}
        <h3 className="font-display text-2xl md:text-3xl font-semibold text-foreground mb-12">
          What this means for you:
        </h3>
  
        {}
        <div ref={iconsRef} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {benefits.map((benefit, i) => <div key={i} data-index={i} className="p-8 rounded-lg bg-primary-light shadow-soft border border-muted/20 flex flex-col items-center text-center transition-all duration-700" style={{
          opacity: iconsVisible ? 1 : 0,
          transform: iconsVisible ? "translateY(0)" : "translateY(20px)",
          transitionDelay: benefit.delay
        }}>
              <div className="mb-6 p-4 rounded-full bg-white shadow-sm">
                <benefit.Icon className="w-8 h-8 text-[#a03223]" strokeWidth={1.5} />
              </div>
              <p className="text-foreground font-medium leading-relaxed">
                {benefit.text}
              </p>
            </div>)}
        </div>
  
        {}
        <div ref={paragraphRef} className="transition-all duration-700" style={{
        opacity: paragraphVisible ? 1 : 0,
        transform: paragraphVisible ? "translateY(0)" : "translateY(20px)"
      }}>
          <p className="whitespace-pre-line text-foreground max-w-3xl mx-auto leading-relaxed !text-base">This approach allows <span className="font-semibold">KS LUXURY RENOVATIONS</span> to deliver refined results with efficiency and precision.</p>
        </div>
      </div>
  
      {}
      <style>{`
        @keyframes drawIn {
          0% {
            opacity: 0;
            stroke-dasharray: 100;
            stroke-dashoffset: 100;
          }
          100% {
            opacity: 1;
            stroke-dasharray: 100;
            stroke-dashoffset: 0;
          }
        }
      `}</style>
    </section>;
}